module.exports = __webpack_public_path__ + "static/media/call_overview.c6650156.svg";